import { useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomCard, Title } from "../../Utils/UI/Text";
import TransportTypesBoard from "./TransportTypesBoard";
import { getTransportTypes } from "../Application/TransportTypes.business";
import {
  getTransportTypesSelector,
  getTransportTypesCountSelector,
} from "../Infrastructure/TransportTypes.reducer";
import "./TransportTypes.css";
import ExportButtonElement from "../../Layout/DesignSystem/ExportButton/Button";

const TransportTypes = () => {
  const transportTypes = useSelector(getTransportTypesSelector);
  const totalCountTransportTypes = useSelector(getTransportTypesCountSelector);

  useEffect(() => {
    getTransportTypes();
  }, []);
  return (
    <>
      <Title
        children="Centros de Costos"
        childrenThree={
          <ExportButtonElement
            type={"transportTypes"}
            text={"Exportar"}
            // filter={}
          />
        }
      />
      <CustomCard>
        <TransportTypesBoard
          transportTypes={transportTypes}
          getTransportTypes={getTransportTypes}
          totalCountTransportTypes={totalCountTransportTypes}
        />
      </CustomCard>
    </>
  );
};

export default TransportTypes;
